import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Loader } from 'components/Loader';
import { setupStatUsers } from 'helpers/reactHelper';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TeamStats } from 'redux/models/stat';
import { RootStore } from 'redux/store';
import { getTeamUserStats } from 'redux/thunks/team';
import './MyStats.scss';

const MyStats: React.FC = () => {
	const dispatch = useDispatch();
	const [stats, setStats] = useState(null as TeamStats | null);
	const [tableRows, setTableRows] = useState([]);
	const userState = useSelector((store: RootStore) => store.user);
	const teamState = useSelector((store: RootStore) => store.team);

	function createRow(name: string, value: any) {
		return { name, value };
	}

	const createTableRows = useCallback(() => {
		let rows: any = [];
		if (stats) {
			rows.push(createRow('Tokens Received', stats.tokensReceived));
			rows.push(createRow('Posts Created', stats.postsCreated));
			rows.push(createRow('Subposts Created', stats.subpostsCreated));
			rows.push(createRow('Tokens Given', stats.tokensGiven));
			rows.push(createRow('Subposts Tokens Given', stats.subpostTokensGiven));
			rows.push(createRow('Most Tokens Given in a Single Post', stats.mostTokensGivenInSinglePost));
			rows.push(createRow('Most Tokens Given in a Single Subpost', stats.mostTokensGivenInSingleSubpost));
			rows.push(createRow('Likes Received', stats.likesReceived));
			rows.push(createRow('Likes Given', stats.likesGiven));
			rows.push(createRow('Users Received From', setupStatUsers(stats.usersReceivedFrom)));
			rows.push(createRow('Users Given To', setupStatUsers(stats.usersGivenTo)));
		}
		setTableRows(rows);
	}, [stats]);

	useEffect(() => {
		if (userState.selectedTeam) {
			dispatch(getTeamUserStats(userState.selectedTeam.teamId, userState.userId));
		}
	}, [userState.selectedTeam, userState.userId, dispatch]);

	useEffect(() => {
		if (!teamState.statsLoading) {
			setStats(teamState.stats);
		}
		createTableRows();
	}, [teamState.stats, teamState.statsLoading, createTableRows]);

	useEffect(() => {
		createTableRows();
	}, [stats, createTableRows]);

	return (
		<>
			<Grid container direction='column' alignContent='center' alignItems='center'>
				{teamState.statsLoading ? (
					<div className='loader-wrapper'>
						<Loader />
					</div>
				) : tableRows.length > 0 ? (
					<TableContainer component={Paper} className='stats-table'>
						<Table aria-label=''>
							<TableHead>
								<TableRow>
									<TableCell className='table-title'>
										My Stats {userState.selectedTeam?.currentSeasonName ? <>for {userState.selectedTeam.currentSeasonName}</> : <></>}
									</TableCell>
									<TableCell align='right'></TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{tableRows.map((row: any) => (
									<TableRow key={row.name}>
										<TableCell component='th' scope='row'>
											{row.name}
										</TableCell>
										<TableCell align='right'>{row.value}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				) : (
					<div className='no-posts-message'>No stats to be found.</div>
				)}
			</Grid>
		</>
	);
};

export default MyStats;
